import {API_URL} from 'utils/constants/app';
import {RequestHelper} from 'utils/helpers/RequestHelper';

const productTestServiceUrl = `${API_URL}/productTest`;

const getProductTestsByTestNumber = (productTestSearchData, signal) =>
  RequestHelper.POST(`${productTestServiceUrl}/productTestsByTestNumber`, productTestSearchData, { signal });

const getProductTestsUnreadNotes = laboratoryId =>
  RequestHelper.GET(`${productTestServiceUrl}/${laboratoryId}/unreadNotes`);

const getProductTestDetails = (ptldId) =>
  RequestHelper.GET(`${productTestServiceUrl}/${ptldId}/details`);

const getProductTestApplications = (ptldRecid) =>
  RequestHelper.GET(`${productTestServiceUrl}/${ptldRecid}/applications`);

const getProductTestTypes = () =>
  RequestHelper.GET(`${productTestServiceUrl}/productTestType`);

const getCustomerStatuses = () =>
  RequestHelper.GET(`${productTestServiceUrl}/customerStatuses`);

const getNotesByPtldId = ptldId =>
  RequestHelper.GET(`${productTestServiceUrl}/${ptldId}/notes`);

const getUnreadNotesNumberByPtldId = ptldId =>
  RequestHelper.GET(`${productTestServiceUrl}/${ptldId}/unreadNotesNumber`);

const getProductTestsDetailedStats = (filter, signal) =>
  RequestHelper.POST(`${productTestServiceUrl}/detailedStats`, filter, { signal });

const getCompanyOptionsForDetailedStatisticsByLaboratory = (filter, signal) =>
  RequestHelper.POST(`${productTestServiceUrl}/detailedStats/companyOptions`, filter, { signal });

const modifyTestDetails = (ptldId, testDatas) =>
  RequestHelper.POST(`${productTestServiceUrl}/${ptldId}/modify`, testDatas );

const uploadProductTestLaboDetailDocument = (ptldId, formData) =>
  RequestHelper.POST_FORMDATA(`${productTestServiceUrl}/${ptldId}/documents`, formData);

const uploadProviderBillDocument = (ptldId, formData) =>
  RequestHelper.POST_FORMDATA(`${productTestServiceUrl}/${ptldId}/providerBill`, formData);

const deleteProductTestLaboDetailDocument = (ptldId, fileId) =>
  RequestHelper.DELETE(`${productTestServiceUrl}/${ptldId}/documents/${fileId}`);


export const ProductTestService = {
  getProductTestsByTestNumber,
  getProductTestsUnreadNotes,
  getProductTestsDetailedStats,
  getCompanyOptionsForDetailedStatisticsByLaboratory,
  getProductTestApplications,
  getProductTestTypes,
  getCustomerStatuses,
  getProductTestDetails,
  getUnreadNotesNumberByPtldId,
  modifyTestDetails,
  getNotesByPtldId,
  uploadProductTestLaboDetailDocument,
  uploadProviderBillDocument,
  deleteProductTestLaboDetailDocument
};